import { DataBean } from "../DataBean";

export class ProductionPlan extends DataBean {



    public async getProductionPlanCatalog(idProduct:any,year:any,month:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProductionPlanCatalog_Number_Number_Number_Number_Number", [idProduct,year,month,page,recordsPerPage]);
    }
    public async updateProductionPlan(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ProductionPlan_updateProductionPlan_com.quickdataerp.bean.productionorders.ProductionPlan", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.productionorders.ProductionPlan"
            }
        ]);
    }
}